import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const TableDownstreamMetricsWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query TableDownstreamMetricsWithoutPersonalSpaceQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  tables(filter: { id: $tableId }) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
